// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"228":"a78e4105","335":"3ffd4e9a","398":"cad0d31b","517":"eaedfe16","734":"bf41bbf3","751":"4ad1621d","825":"3b1a8e61","936":"bdd04beb","990":"119551a0"}[chunkId] + ".chunk.js";
};